export namespace IEnterpriseCertification {
  export namespace Common {
    /** 认证状态 */
    export enum EnterpriseCertificationStatus {
      /** 未认证 */
      UNCERTIFIED = 'Uncertified',
      /** 已认证 */
      CERTIFIED = 'Certified',
      /** 认证中 */
      ING = 'ING',
    }

    // 认证类型
    export enum CertificationType {
      /** 个人 */
      INDIVIDUAL = 'Individual',
      /** 企业 */
      ENTERPRISE = 'Enterprise',
    }

    // 认证回调
    export enum CertificationCode {
      /** 认证成功 */
      SUCCESS = '0',
      /** 认证失败 */
      FAIL = '1',
    }
  }

  export namespace Request {
    /** 获取认证链接 */
    export interface GetCertificationLinkParams {
      certification_type: Common.CertificationType;
      redirect_url: string;
    }
  }

  export namespace Response {
    /** 获取认证链接 */
    export interface GetCertificationLinkRes {
      /** 长链接 */
      url: string;
      /** 短链接 */
      short_link: string;
      /** 认证流程ID */
      flow_id: string;
    }
  }
}
